import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { LocationQueryRaw } from 'vue-router'

export interface BreadcrumbRoute {
  name: string
  path: string
  fullPath: string
  query: LocationQueryRaw
}

export const useBreadcrumbStore = defineStore(
  'breadcrumb',
  () => {
    const routes = ref<BreadcrumbRoute[]>([])

    const setRoutes = (route: BreadcrumbRoute) => {
      const existsIndex = routes.value.findIndex((item) => item.path === route.path)
      const hasLogin = routes.value.some((item) => item.path === '/login')
      
      if (existsIndex !== -1) {
        const currentItem = routes.value[existsIndex]
        const isQuerySame = JSON.stringify(currentItem.query) === JSON.stringify(route.query)
        if (!isQuerySame) {
          routes.value[existsIndex] = route
        }
      } else if (!hasLogin) {
        routes.value.push(route)
      }
    }

    const updateRoutes = (newRoutes: BreadcrumbRoute[]) => {
      routes.value = newRoutes
    }

    const getRoutes = () => {
      return routes.value
    }

    const clearRoutes = () => {
      routes.value = []
    }

    return {
      routes,
      setRoutes,
      updateRoutes,
      getRoutes,
      clearRoutes,
    }
  },
  {
    persist: {
      key: `${import.meta.env.VITE_STOTRE_NAME}_BREADCRUMB`,
      storage: localStorage,
    },
  }
)
